import { EApplyForPublicationStatus, PostApplyFormPublicationsMappers } from './types';

export const mappers: PostApplyFormPublicationsMappers = {
  200: () => ({ status: EApplyForPublicationStatus.Success }),
  400: ({ message }) => ({ status: EApplyForPublicationStatus.Error, message }),
};
